import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components//Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import ButtonWithSVG from "../../../Kryzen Alpha App/Components/layouts/button_with_svg";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import { useDispatch, useSelector } from "react-redux";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import PriceWatcherScrapperTable from "./Price Watcher Scrapper/price_watcher_scrapper_table";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcSalesPerformance } from "react-icons/fc";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import {setPriceScrapperPage} from "../../redux/Pagination/pagination"

const PriceWatcherScrapper = () => {
  const user = useSelector((store) => store.login.user);
   const dispatch = useDispatch();
    const page = useSelector((state) => state.pagination.priceScrapperPage);
  // const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [agro, setAgro] = useState();
  let [filters, setFilters] = useState({
    plantName: "",
  });

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/priceWatcherScrapper/getPriceScrapper/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.priceWatcherData);
          setTotalPages(Math.ceil(res.data?.priceWatcherCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [page]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/priceWatcher/getAgronomyImage/", page)
    )
      .then((res) => {
        if (res.status === 200) {
          setAgro(res.data?.agronomyWiki);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  }, [page]);

  // console.log(data);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcSalesPerformance className="fs-1 me-1" />
                    Price Watcher Scrapp
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                {/* <div className="col-auto ms-auto d-print-none">
                  {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                    process.env.REACT_APP_ROLE_ADMIN_S === user.Role || process.env.REACT_APP_ROLE_SALESCOORDINATOR === user.Role ? (
                    <div className="d-flex d-none d-sm-block">
                      <ButtonWithSVG
                        href={"/buyers-price-watcher/new"}
                        buttonText="Create New Price Tacking"
                        svg={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 5l0 14" />
                            <path d="M5 12l14 0" />
                          </svg>
                        }
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                </div> */}
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-md-3 d-none d-lg-block d-md-block">
                  <CustomViedoCard
                    viedoLink={"https://www.youtube.com/embed/_pFbFKopLnU"}
                    id={"model-viedo"}
                    name={"price watcher"}
                  ></CustomViedoCard>
                </div>
                <div className="col-md-9 mt-2">
                  <div className="card">
                    {data && (
                      <PriceWatcherScrapperTable
                        data={data}
                        agro={agro}
                        currentPage={page}
                        itemsPerPage={50}
                      />
                    )}

                    {/* <div className="btn-list justify-content-center">
                      <div className="d-md-none mt-3 mb-3">
                        <ButtonWithSVG
                          href={"/buyers-price-watcher/new"}
                          buttonText="Create New Price Tacking"
                          svg={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          }
                        />
                      </div>
                    </div> */}

                    <Pagination
                      page={page}
                      setPage={(newPage) => dispatch(setPriceScrapperPage(newPage))}
                      totalPages={totalPages}
                      pageDatalength={data?.priceWatcherData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-block d-md-none d-lg-none">
            <CustomViedoCard
              viedoLink={"https://www.youtube.com/embed/_pFbFKopLnU"}
              id={"model-viedo2"}
              name={"price watcher"}
            ></CustomViedoCard>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PriceWatcherScrapper;
